import { API_BASE_URL } from '../config';

/** Row from GET /api/employees/management-list */
export type EmployeeManagementRowApi = {
  id: string;
  empId: string;
  name: string;
  registrationDate: string;
  birthDate: string;
  email: string;
  status: string;
  /** active | resigned | rehire_in_progress */
  hireLifecycle: string;
  invitationId: string;
  /** Prefer for archive viewer during rehire */
  archiveInvitationId: string;
  gender: string;
  finalizedAt: string;
  needsFinalize: boolean;
};

export async function fetchEmployeeManagementList(): Promise<EmployeeManagementRowApi[]> {
  const res = await fetch(`${API_BASE_URL}/api/employees/management-list`);
  if (!res.ok) {
    throw new Error('Failed to load employee management list');
  }
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}
